import React, { useState } from 'react';
import verticalStyles from './ThemeCardSwatch.scss';
import liteSitePreviewStyles from '../liteSitePreview.scss';
import Swatch from '../Swatch';
import classNames from 'classnames';
import { ThemeFamily } from '../ThemeCard';

interface DisplaySwatchProps {
  themeFamily: ThemeFamily | null;
  selected?: number | null;
  currentTheme?: number | null;
  onClick?: (themeId: number) => void;
  maxThemesToShow?: number;
  isCenterAligned?: boolean;
}

export const DisplaySwatch: React.FC<DisplaySwatchProps> = ({
  themeFamily,
  selected,
  currentTheme,
  onClick,
  maxThemesToShow = 6,
  isCenterAligned = false,
}) => {
  const [showMore, setShowMore] = useState(false);

  if (themeFamily?.themes && themeFamily.themes.length >= 0) {
    const themesToShow =
      showMore || themeFamily.themes.length <= maxThemesToShow
        ? themeFamily.themes
        : themeFamily.themes.slice(0, maxThemesToShow);

    return (
      <div
        className={classNames(verticalStyles.themeCardSwatch__swatchWrapper, liteSitePreviewStyles.swatchContainer, {
          [verticalStyles.themeCardSwatch__swatchWrapper__expanded]: showMore,
        })}
      >
        <div
          className={classNames(verticalStyles.themeCardSwatch__swatchContainer, {
            [verticalStyles.themeCardSwatch__swatchContainer__centerAligned]: isCenterAligned,
          })}
        >
          {themesToShow.map(colorwayTheme =>
            colorwayTheme?.id ? (
              <Swatch
                familyTheme={colorwayTheme}
                onClick={onClick}
                selected={!!(selected && selected === colorwayTheme?.id)}
                isCurrentTheme={!!(currentTheme && currentTheme === colorwayTheme?.id)}
                key={colorwayTheme.id}
              />
            ) : null
          )}
        </div>
        {themeFamily.themes.length > maxThemesToShow && (
          <div
            className={classNames(verticalStyles.themeCardSwatch__showMoreStylesButton__container, {
              [verticalStyles.themeCardSwatch__showMoreStylesButton__container__centerAligned]: isCenterAligned,
            })}
          >
            <button
              className={verticalStyles.themeCardSwatch__showMoreStylesButton__button}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? 'Show less' : `+ ${themeFamily.themes.length - maxThemesToShow}`}
            </button>
          </div>
        )}
      </div>
    );
  }

  return null;
};
